import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Badge compacto de rating para cards de curso
 * Exibe: ⭐ 4.8 (127)
 */
const RatingBadge = ({ courseId, className = '' }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/reviews/course/${courseId}/stats`);
        setStats(res.data);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error('Erro ao carregar estatísticas de avaliações:', err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [courseId]);

  if (loading || !stats || stats.total_reviews === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="rating-badge">
      <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
      <span className="text-sm font-medium text-white">
        {stats.average_rating.toFixed(1)}
      </span>
      <span className="text-xs text-gray-400">
        ({stats.total_reviews})
      </span>
    </div>
  );
};

export default RatingBadge;
